<template>
  <svg
    v-if="$options.svgSprite"
    style="display: none;"
    width="0" height="0"
    v-html="$options.svgSprite"
  >
  </svg>
</template>

<script>
function getSymbols(svgContext) {
  return svgContext.keys().map((path) => {
    const content = svgContext(path);
    const id = path.replace(/^\.\/(.*)\.\w+$/, '$1');
    return content.replace('<svg', `<symbol id="icon-${id}"`).replace('svg>', 'symbol>');
  });
}

export default {
  name: 'Icons',
  props: {
    /**
     * Используется, когда нужно включить в спрайт иконки из локальной папки проекта.
     * Передаётся require.context.<br><br>
     * Синтаксис require.context:<br>
     * <code>require.context(directory, useSubdirectories, regExp)</code><br><br>
     * Пример значения:
     * <code style="white-space: pre-wrap; word-break: break-all;">
     * require.context(
     *  '!svg-inline-loader?removeTags=true&removeSVGTagAttrs=false!../src/assets/icons',
     *  false,
     *  /\w+\.svg$/i,
     * )
     * </code><br><br>
     * <b>Требует установки пакета svg-inline-loader!</b><br><br>
     */
    iconsContext: Function,
  },
  svgSprite: null,
  created() {
    // Design system icons
    const globalIcons = getSymbols(require.context(
      '!svg-inline-loader?'
      + 'removeTags=true&removeSVGTagAttrs=false'
      + '!../icons',
      false,
      /\w+\.svg$/i,
    ));

    // Local project icons
    const localIcons = this.iconsContext
      ? getSymbols(this.iconsContext)
      : [];

    const icons = [
      ...localIcons,
      ...globalIcons,
    ];

    this.$options.svgSprite = icons.join('\n');
  },
};
</script>
